import { render, staticRenderFns } from "./RequestTypesButtons.vue?vue&type=template&id=6ad71eb7&scoped=true"
import script from "./RequestTypesButtons.vue?vue&type=script&lang=js"
export * from "./RequestTypesButtons.vue?vue&type=script&lang=js"
import style0 from "./RequestTypesButtons.vue?vue&type=style&index=0&id=6ad71eb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad71eb7",
  null
  
)

export default component.exports